import {Injectable} from '@angular/core';
import {HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs/Observable';
import {MasbitHttpService} from '../../common/http/masbit-http.service';

@Injectable()
export class UserListService {
  constructor(private httpClient: MasbitHttpService) { }

  getUsers(formData: any): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient
      .post(environment.apiUrl + '/user/list', formData);
  }

  unlockUser(obj: any): Observable<any> {
    return this.httpClient.put(environment.apiUrl + '/user/block_unblock', obj);
  }

  getGroupList(sortString : string): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    };
    return this.httpClient.post(environment.apiUrl + '/group/list',{'sortString' : sortString});
  }

  createUser(userData: any): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/user/create', userData);
  }

  deleteUsers(userData: Array<number>): Observable<any> {
    return this.httpClient.delete(environment.apiUrl + '/user/delete', new HttpParams().set('id', JSON.stringify(userData)));
  }

  assignUsersToGroup(selectedUser: any, groupId: any): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/group/user/assign', {
      id: groupId,
      userIds: selectedUser
    });
  }

  getSetList(): Observable<any> {
    return this.httpClient
      .post(environment.apiUrl + '/set/list');
  }

  createGroup(groupData: any): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/group', groupData);
  }
  updateUser(userData: any): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/user/update', userData);
  }

  getUsersFilterList(formData: any): Observable<any> {
    return this.httpClient.post(environment.apiUrl + '/user/list', formData);
    // return this.httpClient.post(environment.apiUrl + '/user/list/no_loader', formData);
  }
  getListOfUniqueDomains(): Observable<any> {
    return this.httpClient.get(environment.apiUrl + '/user/unique_domains');
  }

}
